module.exports = __webpack_public_path__ + "img/tshirt.46e8888a.png";